module.exports = __webpack_public_path__ + "assets/img/address_img.814abfc1.png";